var path = '/modules/bo/option-links/components/entity-option-links/component.tpl.html';
var html = "<listview store=\"vm.store\" ng-if=\"vm.showStore\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/option-links/components/entity-option-links/component.tpl.html
// module id = 2064
// module chunks = 1